import React, { Component } from 'react';
import DoorLock_Lock_Unlock from './Components/DoorLock_Lock_Unlock';
import { pushCommand, pushGroupCommand, isEmpty, addAnimation } from '../../../Common/Common';
import Error_Message from './Components/Error_Message';

export default class DoorLockOperation extends Component {
	constructor(props) {
		super(props);
		let lock_unlock = 'open'
		if (!isEmpty(this.props.point_info)) {
			if (this.props.point_info.lock != null) lock_unlock = this.props.point_info.lock;
		}

		this.state = {
			lock_unlock: lock_unlock,
		}
	}

	handleSendCommand = (command, val) => {
		// Check whether it is a point operation or group operation
		if (this.props.group_id != null) {
			pushGroupCommand(command, val, this.props.group_id);
		} else if (this.props.point_id != null) {
			this.target_id = this.props.point_id;
			pushCommand(command, val, this.props.point_id);
		}
	}

	handleDoorLockOperation = () => {
		let action = 'close';
		let elem = document.getElementById('icon_container');

		if (this.state.lock_unlock == 'close') {
			action = 'open';
			addAnimation(elem, 'fadeInLong', () => { }, 2000)
			this.setState({ lock_unlock: 'open' });
		} else {
			addAnimation(elem, 'fadeOutLongFast', () => {
				this.setState({ lock_unlock: 'close' });
			}, 200)
		}
		let command = 'lock';
		this.handleSendCommand(command, action);
	}

	render() {
		let icon_width = 150;
		let error_message = '';
		let is_show_error_message = false;

		if (this.props.point_id != null && !isEmpty(this.props.point_info)) {
			if (this.props.point_info.error != null) {
				//check if device has device error
				let device_error = this.props.point_info.error;
				for (var key in device_error) {
					if (device_error[key]) {
						error_message = key;
						is_show_error_message = true;
					}
				}
			}
		}


		return (
			<div id='doorlock_operation' >
				<div>
					{/* Lock/Unlock Button */}
					<div id='icon_container' style={{ cursor: 'pointer', verticalAlign: 'top', marginTop: 20 }} onClick={() => { this.handleDoorLockOperation() }}>
						<DoorLock_Lock_Unlock
							style={{ width: icon_width, padding: 20, borderRadius: 20, boxShadow: '0 0 20px rgba(0, 0, 0, 0.2)' }}
							point_id={this.props.point_id}
							point_info={this.props.point_info}
							receiver={this.props.receiver}
							lock_unlock={this.state.lock_unlock}
						/>
					</div>
					{is_show_error_message ?
						<div id='error_message'>
							<Error_Message
								deviceErrorMessage={error_message}
							/>
						</div> : null}
				</div>
			</div>
		)
	}
}